import {
  AgricultureIcon,
  UtilitiesIcon,
  FinanceIcon,
  HealthcareIcon,
  IndustrialsIcon,
  LifestyleIcon,
  RealEstateIcon,
  RetailIcon,
  SpecialistServicesIcon,
  TechnologyIcon,
  TransportIcon,
} from '@tumelo/designsystem'
import React from 'react'
import { IndustryCategory } from '../../domain/NAICS'

interface Props {
  industryCategory?: IndustryCategory
  imageStyle?: React.CSSProperties
}

export const IndustryIcon: React.FC<Props> = ({ industryCategory, imageStyle }) => {
  switch (industryCategory) {
    case IndustryCategory.AGRICULTURE_AND_FOOD:
      return <AgricultureIcon style={imageStyle} />
    case IndustryCategory.ENERGY_AND_UTILITIES:
      return <UtilitiesIcon style={imageStyle} />
    case IndustryCategory.FINANCE:
      return <FinanceIcon style={imageStyle} />
    case IndustryCategory.HEALTHCARE:
      return <HealthcareIcon style={imageStyle} />
    case IndustryCategory.INDUSTRIAL:
      return <IndustrialsIcon style={imageStyle} />
    case IndustryCategory.LIFESTYLE:
      return <LifestyleIcon style={imageStyle} />
    case IndustryCategory.REAL_ESTATE:
      return <RealEstateIcon style={imageStyle} />
    case IndustryCategory.RETAIL:
      return <RetailIcon style={imageStyle} />
    case IndustryCategory.TECH:
      return <TechnologyIcon style={imageStyle} />
    case IndustryCategory.TRANSPORT_AND_VEHICLES:
      return <TransportIcon style={imageStyle} />
    case IndustryCategory.SPECIALIST_SERVICES:
      return <SpecialistServicesIcon style={imageStyle} />
    default:
      return <IndustrialsIcon style={imageStyle} />
  }
}
